if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.trigger = document.querySelector(this.dataset.triggerSelector);
        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.loading__spinner');

        if (this.trigger) {
          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              // !isIntersecting is also true before the trigger has ever been
              // scrolled to (e.g. it's below the fold on load) — only show
              // the sticky bar once it's been scrolled PAST, i.e. its own
              // top edge has moved above the top of the viewport.
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('sticky-add-to-cart--visible', scrolledPast);
            },
            { threshold: 0 }
          );
          this.visibilityObserver.observe(this.trigger);

          // product-form.js only ever toggles loading/disabled state on the
          // original submit button it queried at construction time, so this
          // duplicate button has to mirror that state itself to avoid looking
          // unresponsive while an add-to-cart request triggered from here is
          // still in flight.
          this.triggerObserver = new MutationObserver(() => this.syncFromTrigger());
          this.triggerObserver.observe(this.trigger, {
            attributes: true,
            attributeFilter: ['class', 'aria-disabled'],
          });
        }

        this.querySelector('[data-sticky-share]')?.addEventListener('click', () => this.share());

        // The Metal/Ring Size chips are rendered once from the page's initial
        // selected variant; product-info.js only refreshes a fixed whitelist
        // of element ids on an AJAX variant swap (this bar's chips aren't in
        // it), so they'd otherwise go stale the moment someone picks a
        // different option without a full page reload.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.triggerObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      onVariantChange({ data: { sectionId, variant } }) {
        if (sectionId !== this.dataset.sectionId || !variant) return;
        this.querySelectorAll('[data-sticky-option-value]').forEach((valueEl) => {
          const index = valueEl.closest('[data-sticky-option-index]')?.dataset.stickyOptionIndex;
          const value = index && variant[`option${index}`];
          if (value) valueEl.textContent = value;
        });
      }

      syncFromTrigger() {
        if (!this.trigger || !this.submitButton) return;
        const isLoading = this.trigger.classList.contains('loading');
        this.submitButton.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
        if (this.trigger.getAttribute('aria-disabled') === 'true') {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      share() {
        const url = window.location.href;
        if (navigator.share) {
          navigator.share({ url }).catch(() => {});
          return;
        }
        navigator.clipboard?.writeText(url);
      }
    }
  );
}
